import React, { Component } from 'react';
import service from "../assets/images/service-1.gif";
import pscroll from "../assets/images/scroll.gif";
import des_webs from "../assets/images/des_webs.png";
import design_3 from "../assets/images/design_3.png";
import ser_3 from "../assets/images/ser-3.png";
import ser_5 from "../assets/images/ser-5.png";
import ser_6 from "../assets/images/ser-6.png";

class Services extends Component {

  render() {
    return (


    			<section className="Services">

    					<div className="width-100">
   <img src={service}  id="aftr-lds" className="img-responsive" alt="Garymark Infotech"/>
</div>
 <img src={pscroll} id="service-scroll" className="scroll-pos hidden-xs hidden-sm " alt="Enterprise Resource Planning"/>
<div className="row" id="nav-fix">
    <div className="navbar bg-dk-black  null-margin-btm">
        <div className="col-md-10 col-md-offset-2 col-xs-12 col-sm-12  ">  
           <ul className="nav nav-tabs">
			  <li className="active"><a data-toggle="tab" href="#home"><b><i className="fa fa-paint-brush "> &nbsp; WEB DESIGNING </i></b></a></li>
			  <li><a data-toggle="tab" href="#menu1"><b><i className="fa fa-code "> &nbsp; WEB DEVELOPMENT </i></b></a></li>
			  <li><a data-toggle="tab" href="#menu2"> <b><i className="fa fa-dashboard "> &nbsp; SEARCH ENGINE OPTIMISATION </i></b></a></li>
			  <li><a data-toggle="tab" href="#menu3"><b><i className="fa fa-pie-chart "> &nbsp; ENTERPRISE RESOURCE PLANNING </i></b></a></li>
			</ul>
 

       


   </div>
</div>

<div className="tab-content">
  <div id="home" className="tab-pane fade in active">
   <div class="container">
<section class="webdesign">


 <div class="container add-m-top-100">
    <div id="demo-3" class="wbdsgn">
        <div class="row" >
            <div class="col-md-6 add-m-top-10">
                <div class="icon-circle ">
                    <p class="fnt-30 hidden-xs hidden-sm">1</p>
                </div>
                <h3>
                  We Build Great Websites that are Mobile Friendly
                </h3>
                <h4><strong>Good-Bye to Ugly Sites. It's time to Ring-in the New and Embrace Technology.</strong></h4>
                <p>We have a great team of developers and our designers have a pretty good design sense. We will also ensure that your website is well optimized for search engines.</p>

            </div>
            <div class="col-md-6">
             &nbsp;
         </div>
     </div>
     <div class="row" >
        <div class="col-md-6 add-m-lft-30">
            <img src={des_webs} class="img-responsive" alt="Website Designing"/>
        </div>
    </div>
    <div class="row" >
        <div class="col-md-8">
        <div class="icon-circle-1 add-p-t-50 add-m-t--3 ">
<p class="fnt-30 hidden-xs hidden-sm">2</p>
</div>

            <h3 class="ta-l">We Love Browser Competability</h3>

            <p>Nowadays everyone’s using a different browser. Between popular options like Firefox, Safari, Chrome and Internet Explorer, which make up close to 98% of the internet market share of browsers, and the other little known browsers like Konqueror, there are a multitude of browsers being used to view your site. </p>
            <p> It’s important that your website is usable across all major media, whether it be popular browsers, mobile devices, or any other web browsing devices. we are here for all your worries </p>
            </div>
            <div class="col-md-4">
                <img src={design_3} alt="" class=" myde  img-responsive"/>
            </div>
        </div>
       
    </div>
</div>

</section>
   </div>



<div  class=" demo-5 null-p null-m parbg"> 
    <div class="container">
      <div class="row">
        <div class="col-md-6 ">
        </div>
        <div class="col-md-6 add-m-top-50">
          <h3 class=" c-w ta-l"> W3C Standard   </h3>
       
          <p class="ta-l c-w">  Compliance with the major W3C standards gives your website a number of important benefits. The most significant advantages derived from W3C compliance are: </p>
<h4 class=" c-w ta-l">Search Engine Optimization </h4>
<p class="ta-l c-w"> Bringing the website into the compliance with the W3C standards involves tangible reduction of the excessive code within the website. This introduces new SEO-related opportunities for your store as less code tend to reduce the code-to-content ration of the website, providing emphasis on the website content rather than on the code.</p>
<p class="ta-l c-w">long with other SEO-wise benefits that include better indexability, compact keyword placement, etc., this makes the whole website more visible to search engine crawlers and spiders, and increases the relevancy of your store pages, which generally improves the store standing with many popular search engines, including Google, Yahoo!, Bing, etc. </p>
<h4 class=" c-w ta-l">Website accessibility and compatibility </h4>
<p class="ta-l c-w">Having a compliant website ensures that it will be properly read and interpreted by all major web browsers. This should help you enhance your customers' experience and cover a greater audience as your store will be displayed correctly regardless your customers' environment. </p>


          </div>
      </div>
  </div>
</div>
  </div>
  <div id="menu1" className="tab-pane fade">
   
<section class="webdevelopment">

 <div class="container">
<div id="demo-9" class="wbdvlpmnt">
        <div class="row" >
            <div class="col-md-6 add-m-top-100">
                <div class="icon-circle ">
                    <p class="fnt-30 hidden-xs hidden-sm">1</p>
                </div>
                <h3>
                   CLEAN CODE 
                </h3>
                <p>Our talented programmers live up to mark all your PHP web development requirements including website development, corporate website development, etc. </p>
                <p>Our developers are versed with PHP (LAMP), MySQL, Apache & Linux. This allows us to offer the best solutions and ensure maximum contentment for our customers.  </p>

            </div>
            <div class="col-md-6">
             &nbsp;
         </div>
     </div>
     <div class="row" >
        <div class="col-md-6">
            <img src={ser_3} class="img-responsive" alt="Development Company"/>
        </div>
    </div>
     
    <div class="row" >
        <div class="col-md-6 col-md-offset-6">
        <div class="icon-circle-1 add-p-t-50 add-m-t-50 ">
        <p class="fnt-30 hidden-xs hidden-sm">2</p>
    </div>

            <h2 class="ta-l">Use Of Model View Controller</h2>
            <p>We make ample use of MVC (model view controller). This powerful architecture is deployed proficiently to create expressive, efficient as well as reusable web applications. <br/>
            We enable our customers to take advantage of all PHP benefits. Our <b>developers</b> ensure fast data processing & compatibility with diverse OS by developing a website. </p>
            </div>
            <div class="col-md-6 col-md-offset-6">
               <img src={ser_5} alt="Enterprise Resource Planning" class="img-responsive"/>
            </div>
          
        </div>
        <div class="row" >
            <div class="col-md-6">

            <div class="icon-circle-1 add-p-t-50 add-m-t-50 ">
            <p class="fnt-30 hidden-xs hidden-sm">3</p>
            </div>
            <h2 class="ta-l">Affordable Pricing</h2>
            <p>We render the best PHP <b>web development</b> services at affordable pricing. Our solutions provide performance guarantee by following specified needs of the clients.</p>
           
               <img src={ser_6}  class="img-responsive " alt="SEO"/>
            </div>
        </div>
</div>   
</div>
</section>


<div  class="demo-6 null-p null-m webbg"> 
   <div class="blackcover">
    <div class="container">
      <div class="row">
       
        <div class="col-md-12 add-m-top-50">
          <h2 class=" c-w ta-l">Why Choose Our Developers</h2>
           <p class="ta-l c-w">   We  Optimise our site with maximum efficiency. We utilize different methods to accomplish it</p>
         </div>
          </div>
          <div class="row">
         <div class="col-md-6">
        <h4 class="ta-l c-w"><i class="fa fa-fw fa-2x fa-file-archive-o"></i>
PHP programmers with 5+ years experience </h4>
        </div>
         </div>
            <div class="row">
         <div class="col-md-6">
         <h4 class="ta-l c-w"><i class="fa fa-fw fa-2x  fa-tachometer"></i>100% delivery ratio</h4>
        
         </div>
         </div>

          <div class="row">
         <div class="col-md-6">
         <h4 class="ta-l c-w"><i class="fa fa-fw fa-2x fa-sitemap"></i>
Proven outsourcing process for PHP web development</h4>
         
         </div>
         </div>

          <div class="row add-m-btm-50">
         <div class="col-md-6">
         <h4 class="ta-l c-w"><i class="fa fa-fw fa-2x fa-picture-o"></i>
Transparency regarding the project progress</h4>
          
           
         </div>
         </div>
          
          
          
         

          
     
  </div>
  </div>
</div>






  </div>
  <div id="menu2" className="tab-pane fade">
    <h3>Menu 2</h3>
    <p>Some content in menu 2.</p>
  </div>
</div>


</div>


    			</section>
    	 );
  }
}

export default Services;



// WEBPACK FOOTER //
// ./src/pages/services.js